// extracted by mini-css-extract-plugin
module.exports = {"heading":"_34tCJTmKfoPAjXRUrAJqd-","alerts":"biICie58tG0wPS9FlPkFv"};